export default __webpack_public_path__ + "static/media/a4-print-label-4-page.ee7fcc2a.svg";